module.exports = __webpack_public_path__ + "static/media/jules_interiors-IG.4205686c.PNG";